/* GGC Tire Finder — free "shop tires by size" widget.
 * Cascading Width -> Aspect ratio -> Wheel diameter, from a tiny size index built from the catalog.
 * On submit -> Shopify's native /collections/tires/<size> tag filter (proven to work).
 * Reuses the .ggc-ymm visual classes so it matches the Nexus look. Self-contained; does NOT
 * touch the YMM widget. When a vehicle->tire-size dataset is added later, the vehicle YMM can
 * resolve a size and reuse this same /collections/tires/<size> path.
 */
(function () {
  "use strict";

  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === "class") el.className = attrs[k];
      else if (k === "text") el.textContent = attrs[k];
      else el.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { el.appendChild(c); });
    return el;
  }
  function opt(v, label, dis, sel) {
    var o = document.createElement("option");
    o.value = v; o.textContent = label;
    if (dis) o.disabled = true; if (sel) o.selected = true;
    return o;
  }

  // DEMO sample of the vehicle->OEM-tire-size data (the paid dataset provides this for every vehicle).
  // Real OEM sizes for the 2015 F-150 shown so you can see the vehicle-based UX with live products.
  // Vehicle -> OE tire size map. Empty until the vehicle->tire-size dataset is loaded;
  // when populated (from Turn14 ACES or a tire-size CSV), the vehicle-aware panel lights up
  // for every vehicle automatically. Until then, customers use the size finder below.
  var DEMO_FITMENT = {};
  function sizePretty(handle) { return handle.replace("-", "/").toUpperCase(); }
  function getActiveVehicle() { try { return JSON.parse(localStorage.getItem("ggc_ymm_active")); } catch (e) { return null; } }

  function TireFinder(root) {
    this.root = root;
    this.indexUrl = root.getAttribute("data-index-url");
    this.collection = root.getAttribute("data-collection") || "tires";
    this.title = root.getAttribute("data-title") || "Find Your Tire Size";
    this.data = null; this.tree = null;
    this.sel = { w: "", a: "", d: "" };
    this.render();
    this.bindLazy();
  }

  // Vehicle-aware panel: when a vehicle is active and we know its OEM tire size, show it up top.
  TireFinder.prototype.vehiclePanel = function () {
    var av = getActiveVehicle();
    var fit = av && av.tag && DEMO_FITMENT[av.tag];
    if (!fit) return null;
    var self = this;
    var box = h("div", { class: "ggc-tirefit" });
    box.appendChild(h("div", { class: "ggc-tirefit__head", text: "Tires for your " + fit.label }));
    var row = h("div", { class: "ggc-tirefit__sizes" });
    var oem = h("button", { class: "ggc-tirefit__size ggc-tirefit__size--oem", type: "button" });
    oem.appendChild(h("span", { class: "ggc-tirefit__badge", text: "OEM" }));
    oem.appendChild(h("span", { text: sizePretty(fit.oem) }));
    oem.addEventListener("click", function () { window.location.assign("/collections/" + self.collection + "/" + fit.oem); });
    row.appendChild(oem);
    (fit.also || []).forEach(function (s) {
      var b = h("button", { class: "ggc-tirefit__size", type: "button", text: sizePretty(s) });
      b.addEventListener("click", function () { window.location.assign("/collections/" + self.collection + "/" + s); });
      row.appendChild(b);
    });
    box.appendChild(row);
    box.appendChild(h("div", { class: "ggc-tirefit__note", text: "Recommended fitment for your vehicle — or pick a size below." }));
    return box;
  };

  TireFinder.prototype.render = function () {
    var self = this;
    this.root.innerHTML = "";
    var wrap = h("div", { class: "ggc-ymm__inner" });
    var vp = this.vehiclePanel();
    if (vp) wrap.appendChild(vp);
    if (this.root.getAttribute("data-show-title") !== "false")
      wrap.appendChild(h("div", { class: "ggc-ymm__title", text: vp ? "Or shop by tire size" : this.title }));
    this.modeSel = document.createElement("select"); this.modeSel.className = "ggc-ymm__select ggc-ymm__select--mode"; this.modeSel.style.display = "none";
    this.modeSel.appendChild(opt("metric", "Car, SUV & street sizes", false, true)); this.modeSel.appendChild(opt("flot", "Truck flotation sizes (35x12.50)"));
    this.modeSel.addEventListener("change", function () { self.setMode(self.modeSel.value); });
    wrap.appendChild(this.modeSel);
    this.fields = h("div", { class: "ggc-ymm__fields" });
    this.selW = this.mkSelect("w", "Width");
    this.selA = this.mkSelect("a", "Aspect ratio");
    this.selD = this.mkSelect("d", "Wheel diameter");
    this.fields.appendChild(this.field("Width", this.selW));
    this.fields.appendChild(this.field("Aspect ratio", this.selA));
    this.fields.appendChild(this.field("Wheel diameter", this.selD));
    wrap.appendChild(this.fields);
    var actions = h("div", { class: "ggc-ymm__actions" });
    this.btn = h("button", { class: "ggc-ymm__btn ggc-ymm__btn--primary", type: "button", text: "Find tires" });
    this.btn.disabled = true;
    this.btn.addEventListener("click", function () { self.go(); });
    this.btnClear = h("button", { class: "ggc-ymm__btn ggc-ymm__btn--clear", type: "button", text: "Clear" });
    this.btnClear.addEventListener("click", function () { self.clear(); });
    actions.appendChild(this.btn); actions.appendChild(this.btnClear);
    wrap.appendChild(actions);
    this.status = h("div", { class: "ggc-ymm__status" });
    wrap.appendChild(this.status);
    this.root.appendChild(wrap);
  };

  TireFinder.prototype.field = function (label, sel) {
    var f = h("label", { class: "ggc-ymm__field" });
    f.appendChild(h("span", { class: "ggc-ymm__label", text: label }));
    f.appendChild(sel);
    return f;
  };
  TireFinder.prototype.mkSelect = function (level, ph) {
    var self = this;
    var s = document.createElement("select");
    s.className = "ggc-ymm__select ggc-ymm__select--" + level;
    s.disabled = true;
    s.appendChild(opt("", "Select " + ph, true, true));
    s.addEventListener("change", function () { self.onChange(level, s.value); });
    return s;
  };
  TireFinder.prototype.bindLazy = function () {
    var self = this, t = function () { self.load(); };
    this.root.addEventListener("mouseenter", t, { once: true });
    this.selW.addEventListener("focus", t, { once: true });
    this.selW.addEventListener("mousedown", t, { once: true });
  };
  TireFinder.prototype.load = function () {
    var self = this;
    if (this.data || this._l) return; this._l = true;
    this.status.textContent = "Loading sizes…";
    fetch(this.indexUrl).then(function (r) { return r.json(); }).then(function (d) {
      self.data = d; self.tree = d.tree; self.metricTree = d.tree; self.flotTree = (d.flotation || {}).tree || null; self.status.textContent = "";
      self.fill(self.selW, Object.keys(self.tree).sort(function (a, b) { return parseFloat(a) - parseFloat(b); }), "Width");
      self.selW.disabled = false;
      if (self.flotTree) self.modeSel.style.display = "";
    }).catch(function () { self._l = false; self.status.textContent = "Could not load sizes. Please retry."; });
  };
  TireFinder.prototype.setMode = function (m) {
    this.tree = (m === "flot" && this.flotTree) ? this.flotTree : this.metricTree;
    this.sel = { w: "", a: "", d: "" };
    var num = function (a, b) { return parseFloat(a) - parseFloat(b); };
    this.fill(this.selW, Object.keys(this.tree).sort(num), m === "flot" ? "Overall diameter" : "Width"); this.selW.disabled = false;
    this.reset(this.selA, m === "flot" ? "Section width" : "Aspect ratio"); this.reset(this.selD, "Wheel diameter"); this.btn.disabled = true;
  };
  TireFinder.prototype.fill = function (s, vals, ph) {
    s.innerHTML = ""; s.appendChild(opt("", "Select " + ph, true, true));
    vals.forEach(function (v) { s.appendChild(opt(v, v)); });
  };
  TireFinder.prototype.reset = function (s, ph) { s.innerHTML = ""; s.appendChild(opt("", "Select " + ph, true, true)); s.disabled = true; };
  TireFinder.prototype.onChange = function (level, v) {
    if (level === "w") {
      this.sel.w = v; this.sel.a = ""; this.sel.d = "";
      if (v && this.tree[v]) { this.fill(this.selA, Object.keys(this.tree[v]).sort(function (a, b) { return parseInt(a) - parseInt(b); }), "Aspect ratio"); this.selA.disabled = false; }
      else this.reset(this.selA, "Aspect ratio");
      this.reset(this.selD, "Wheel diameter");
    } else if (level === "a") {
      this.sel.a = v; this.sel.d = "";
      var node = (this.tree[this.sel.w] || {})[v];
      if (v && node) { this.fill(this.selD, Object.keys(node).sort(function (a, b) { return parseInt(a) - parseInt(b); }), "Wheel diameter"); this.selD.disabled = false; }
      else this.reset(this.selD, "Wheel diameter");
    } else { this.sel.d = v; }
    this.btn.disabled = !this.sizeHandle();
  };
  TireFinder.prototype.sizeHandle = function () {
    var t = this.tree && this.tree[this.sel.w] && this.tree[this.sel.w][this.sel.a];
    return (t && t[this.sel.d]) || "";
  };
  TireFinder.prototype.go = function () {
    var handle = this.sizeHandle(); if (!handle) return;
    // exact-size tag collection (every tire carries a size tag)
    window.location.assign("/collections/" + this.collection + "/" + encodeURIComponent(handle));
  };
  TireFinder.prototype.clear = function () {
    this.sel = { w: "", a: "", d: "" };
    if (this.data) { this.fill(this.selW, Object.keys(this.tree).sort(function (a, b) { return parseInt(a) - parseInt(b); }), "Width"); this.selW.disabled = false; }
    this.reset(this.selA, "Aspect ratio"); this.reset(this.selD, "Wheel diameter");
    this.selW.value = ""; this.btn.disabled = true;
  };

  function init() {
    document.querySelectorAll("[data-ggc-tire]").forEach(function (n) { if (!n.__t) { n.__t = true; new TireFinder(n); } });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  window.GGCTireInit = init;
})();
